import React, { useEffect, useRef, useState } from "react";
import { CircularProgress, Grid } from "@mui/material";
import BreadcrumbComp from "../CommonComponents/Breadcrumb/Breadcrumb";
import Datatable from "../CommonComponents/Datatable/Datatable";
import PaymentRecoveryDetailModal from "./Paymentdetailmodal";
import { LitigationModal } from "./Paymentmodal";
import { PaymentRecoveryListData } from "../../helpers/renderData";
import { toastAlert } from "../../helpers/toastAlert";
import {
  addPaymentRecovery,
  deletePaymentRecovery,
  editPaymentRecovery,
  getPaymentRecoveries,
  getPaymentRecoveryDetail,
} from "../../services/Paymentrecoveryservices";
import { getApiErrorMessage, getApiFieldErrors, isApiSuccess } from "../../utils/apiErrors";
import { withRouter } from "react-router-dom/cjs/react-router-dom";
import { connect } from "react-redux";

import ConfirmDeleteModal from "../CommonComponents/Confrimationmodal";
import { asCustomerList, getCustomers } from "../../services/customerService";
import StartFromInquiryCta from "../CommonComponents/StartFromInquiryCta";

const PaymentRecoveryList = (props) => {
  const [tableData, setTableData] = useState({});
  const [showModal, setShowModal] = useState(false);
  const [modalMode, setModalMode] = useState("add");
  const [selectedPayment, setSelectedPayment] = useState(null);
  const [EditId, setEditId] = useState("");
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedRecovery, setSelectedRecovery] = useState(null);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [deleteId, setDeleteId] = useState("");
  const [searchText, setSearchText] = useState("");
 const [currentPage, setCurrentPage] = useState(1);
 const [rowsPerPage, setRowsPerPage] = useState(10);
 const [TotalRow , setTotalRow] = useState(20);
 const [loading, setLoading] = useState(false);
 const [paymentRows, setPaymentRows] = useState([]);
 const [customerData, setCustomerData] = useState([]);
 const openedFromQuery = useRef("");
  const loadData = async () => {
  setLoading(true)
  try {
    const response = await getPaymentRecoveries(props, currentPage, rowsPerPage, searchText);
    const list = response?.data?.items || [];
    setPaymentRows(list);
    const tableResponse = await PaymentRecoveryListData(list, {
      onEdit: handleEdit,
      onDelete: openDeleteModal,
      onView: handleViewDetails,
    });
    
    setTableData(tableResponse);
    setTotalRow(response?.data?.total);
  } catch (err) {
    toastAlert("Something went wrong while loading Payment Recoveries", "error");
  }
  setLoading(false)
};

  const handleSubmit = async (formData) => {
    try {
      const response =
        modalMode === "add"
          ? await addPaymentRecovery(props, formData)
          : await editPaymentRecovery(props, formData, EditId);

      if (isApiSuccess(response)) {
        toastAlert(
          response?.message ||
            (modalMode === "add"
              ? "Payment Recovery Added Successfully"
              : "Payment Recovery Updated Successfully"),
          "success"
        );
        setShowModal(false);
        loadData();
        return { ok: true };
      }

      return {
        ok: false,
        message: getApiErrorMessage(response),
        fieldErrors: getApiFieldErrors(response, { customerId: "applicantName" }),
      };
    } catch (error) {
      return {
        ok: false,
        message: getApiErrorMessage(error, "Something went wrong"),
        fieldErrors: {},
      };
    }
  };

  const openDeleteModal = (id) => {
    setDeleteId(id);
    setShowDeleteModal(true);
  };

  const confirmDelete = async () => {
    try {
      const response = await deletePaymentRecovery(deleteId, props);
      if(response?.data?.code){
      toastAlert("Payment Recovery Deleted", "success");
      setShowDeleteModal(false)
      }
      setDeleteId("");
      loadData();
    } catch (err) {
      toastAlert("Delete failed", "error");
    }
  };

  const handleEdit = (data) => {
    setSelectedPayment(data);
    setEditId(data?._id);
    setModalMode("edit");
    setShowModal(true);
  };

  const handleAddNew = () => {
    setSelectedPayment(null);
    setEditId("");
    setModalMode("add");
    setShowModal(true);
  };

  const handleViewDetails = (data) => {
    setSelectedRecovery(data);
    setModalOpen(true);
  };

  const closeModal = () => {
    setModalOpen(false);
    setSelectedRecovery(null);
  };
  const itemArray = () => [
    {
      name: "Payment Recovery",
      active: true,
      link: "",
    },
  ];
 useEffect(() => {
    loadData();
  }, [searchText , rowsPerPage , currentPage]);
  useEffect(() => {
    (async () => {
      const customers = await getCustomers(props, 1, 10000000);
      setCustomerData(asCustomerList(customers));
    })();
  }, []);
  useEffect(() => {
    const openId = new URLSearchParams(props.location?.search || "").get("id");
    if (!openId || openedFromQuery.current === openId) return;
    const found = paymentRows.find((row) => String(row._id) === String(openId));
    if (found) {
      openedFromQuery.current = openId;
      handleViewDetails(found);
      return;
    }
    (async () => {
      const res = await getPaymentRecoveryDetail({ recoveryId: openId }, props);
      const record = res?.data || res;
      if (record?._id) {
        openedFromQuery.current = openId;
        handleViewDetails(record);
      }
    })();
  }, [paymentRows, props.location?.search]);

  return (
    <div>
     <Grid
  container
  alignItems="center"
  justifyContent="space-between"
  style={{ marginBottom: 8}}
>
  {/* Breadcrumb : Left */}
  <Grid item>
    <BreadcrumbComp items={itemArray()} />
  </Grid>

  <Grid item>
    <StartFromInquiryCta
      history={props.history}
      inquiryType="payment_recovery"
      message="Use an inquiry when there is a lead. Walk-in files can be added directly."
      onDirectAdd={handleAddNew}
      directLabel="Add file"
      directPermission="create_paymentrecovery"
    />
  </Grid>
</Grid>
      <Grid container className="data-table-main" mt={1}>
        <Grid item xs={12}>
   <div className="card-main" style={{ width: "100%", padding: 12, position: "relative" }}>
            {loading && (
              <div
                style={{
                  position: "absolute",
                  top: "60px",
                  left: "60px",
                  zIndex: 10,
                }}
              >
                <CircularProgress style={{ color: "#5F5BA8" }} size={35} />
              </div>
            )}
            <Datatable
              props={tableData}
              title="Payment Recovery List"
              currentPage={currentPage}
              TotalRow={TotalRow}
              rowsPerPage={rowsPerPage}
              onPageChange={(page, rows) => {
                setCurrentPage(page);
                setRowsPerPage(rows);
              }}
              onSearchChange={(search) => {
                setSearchText(search);
                setCurrentPage(1);
              }}
            />
          </div>
        </Grid>
      </Grid>

      {/* Add/Edit Modal */}
      {showModal && (
        <LitigationModal
          isOpen={showModal}
          mode={modalMode}
          paymentData={selectedPayment}
          customerData={customerData}
          onClose={() => setShowModal(false)}
          onSubmit={handleSubmit}
        />
      )}

      {/* View Detail Modal */}
      {modalOpen && (
        <PaymentRecoveryDetailModal
          isOpen={modalOpen}
          onClose={closeModal}
          recoveryData={selectedRecovery}
          props={props}
        />
      )}

      {/* ⭐ Delete Confirmation Modal */}
      <ConfirmDeleteModal
        open={showDeleteModal}
        onClose={() => setShowDeleteModal(false)}
        onConfirm={confirmDelete}
        message="Are you sure you want to delete this Payment Recovery?"
      />
    </div>
  );
};

const mapStateToProps = (state) => ({
  authData: state.authReducer,
});

export default withRouter(connect(mapStateToProps)(PaymentRecoveryList));
